import { Routes } from "@angular/router";
import { AuthGuard } from "./services/auth-guard.service";
import { LoginComponent } from "./auth/login/login.component";
import { LayoutComponent } from "./layout/layout.component";
export const appRoutes: Routes = [
    {
      path: '',
      component: LayoutComponent,
      canActivate: [AuthGuard],
      children: [
        { 
          path: '', 
          loadChildren: () => import('./layout/layout.module').then(m => m.LayoutModule)
        }
      ]
    },
    {
      path: '',
      component: LoginComponent,
      children: [
        { path: 'login', component: LoginComponent }
      ]
    },
    { path: '**', redirectTo: '' }
];